import { useContext } from 'react';

import { PageBrandingContext } from 'src/contexts/PageBrandingContext';

const usePageBranding = () => useContext(PageBrandingContext);

export default usePageBranding;
